/**
 * @internal
 *
 * Use the `isFocusable` utility function to check whether an element can receive
 * focus.
 */
export function isFocusable(
  // oxlint-disable-next-line typescript/no-explicit-any
  element: any,
) {
  if (element.tabIndex < 0 || element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href;
    case 'INPUT':
      return element.type !== 'hidden';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return element.tabIndex >= 0;
  }
}
